import { type NextPageContext } from 'next'

import { noLayoutConfig } from './NoLayout'
import { primaryLayoutConfig } from './PrimaryLayout'
import { PageLayoutConfig } from './types'

export interface WithLayoutConfig {
  layoutConfig?: PageLayoutConfig
}

export const getLayoutConfigForPageView = ({
  query,
  pageComponent,
}: {
  query: NextPageContext['query']
  pageComponent: WithLayoutConfig
}): PageLayoutConfig => {
  const forcePlainLayout = query?.plain
  const layoutConfig = forcePlainLayout
    ? noLayoutConfig
    : pageComponent.layoutConfig ?? primaryLayoutConfig
  return layoutConfig
}
